import { useState, useCallback, useEffect } from "react";
import classNames from "classnames";

import {
  getPacksCount,
  createPacksCountUrl
} from "../../../../utils/packsCount";
import Spinner from "../../../../components/common/Spinner";
import { Pack } from "../../../../components/laundry/order/Pack";
import css from "./PacksCount.module.scss";

export const PacksCount = ({ startDate, endDate, orders }) => {
  const [packsCount, setPacksCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const totalPacksCount = packsCount.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  const totalRegularOrders = orders.filter(
    ({ order_type }) => order_type !== "collection"
  ).length;
  const totalCollections = orders.filter(
    ({ order_type }) => order_type === "collection"
  ).length;

  const fetchPacksCount = useCallback(async (startDate, endDate) => {
    try {
      setLoading(true);
      const url = createPacksCountUrl(startDate, endDate);
      const { packsCount, error } = await getPacksCount(url);
      if (error) {
        setError(error);
      } else {
        setPacksCount(packsCount.filter(({ quantity }) => quantity > 0));
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPacksCount(startDate, endDate);
  }, [fetchPacksCount, startDate, endDate]);

  if (error) {
    console.warn(error);
    return (
      <div className={css["total"]}>
        An error has occurred while fetching the total linen count
      </div>
    );
  }

  if (loading) {
    return (
      <div className={classNames(css["total"], css["total--loading"])}>
        <Spinner noMargin />
      </div>
    );
  }

  if (!startDate || !endDate || (!orders.length && !totalPacksCount)) {
    return null;
  }

  return (
    <div className={css["total"]}>
      <div>
        <strong>Total:</strong>
      </div>
      <div className={css["total__beds"]}>
        {packsCount.map(({ mattress_size, quantity }, key) => (
          <Pack
            mattressSize={mattress_size}
            quantity={quantity}
            key={key}
            small
          />
        ))}
      </div>
      <div>
        <strong>
          {packsCount.length > 1 && `(${totalPacksCount})`} in{" "}
          {totalRegularOrders} Order
          {totalRegularOrders === 1 ? "" : "s"}; {totalCollections} Collection
          {totalCollections === 1 ? "" : "s"}
        </strong>
      </div>
    </div>
  );
};

export default PacksCount;
